import { useMutation, useQueryClient } from "react-query";
import { message } from "antd";
import { API_URL } from "../../../../BaseUrlApi/Url";
import API from "@Config/axios";

export const useUpdateWhatsappMutation = (userId, parentId, onSuccessCallback) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (whatsappNumber) => {
      const postData = {
        phone_number: whatsappNumber,
      };
      await API.post(`${API_URL}/admin/users/${userId}/add-whatsapp-number`, postData);
    },
    {
      onSuccess: () => {
        message.success("Berhasil menyimpan nomor Whatsapp.");
        queryClient.invalidateQueries(["parentDetail", parentId]);
        if (onSuccessCallback) onSuccessCallback();
      },
      onError: (err) => {
        message.error(err?.response?.data?.message || "Gagal menyimpan nomor Whatsapp.");
      },
    }
  );
};
